<header
    class="flex items-center justify-between h-16 px-6 bg-white dark:bg-gray-800 shadow-sm dark:shadow-gray-900/30 transition-colors">
    <div class="flex items-center space-x-1 min-w-0">
        @if (headerTabs.tabs().length > 0) {
        <!-- Tab navigation -->
        <nav class="hidden sm:flex items-center gap-1">
            @for (tab of headerTabs.tabs(); track tab.value) {
            <button (click)="headerTabs.selectTab(tab.value)"
                class="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors"
                [class]="headerTabs.activeTab() === tab.value
                    ? 'bg-primary/10 text-primary dark:bg-primary/20 dark:text-primary-400'
                    : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700'">
                <i [class]="tab.icon"></i>
                {{ tab.label }}
            </button>
            }
        </nav>
        <h1 class="sm:hidden text-lg font-semibold text-gray-800 dark:text-gray-100 truncate">
            @for (tab of headerTabs.tabs(); track tab.value) {
                @if (headerTabs.activeTab() === tab.value) { {{ tab.label }} }
            }
        </h1>
        } @else if (headerTabs.title()) {
        <!-- Page title with icon -->
        <div class="flex items-center gap-2.5">
            <i [class]="headerTabs.titleIcon() + ' text-primary dark:text-primary-400 text-lg'"></i>
            <h1 class="text-lg font-semibold text-gray-800 dark:text-gray-100">{{ headerTabs.title() }}</h1>
        </div>
        } @else {
        <!-- Desktop breadcrumb trail -->
        <nav class="hidden sm:flex items-center gap-1.5 text-base min-w-0">
            @for (crumb of breadcrumbService.currentBreadcrumbs(); track $index; let last = $last) {
            @if (crumb.url && !last) {
            <a [routerLink]="crumb.url" [queryParams]="crumb.queryParams"
                class="text-gray-500 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors truncate">
                {{ crumb.label }}
            </a>
            <i class="pi pi-angle-right text-sm text-gray-400 dark:text-gray-500"></i>
            } @else {
            <span class="text-gray-800 dark:text-gray-100 font-semibold truncate">{{ crumb.label }}</span>
            }
            }
        </nav>
        <h1 class="sm:hidden text-lg font-semibold text-gray-800 dark:text-gray-100 truncate">
            {{ breadcrumbService.currentTitle() }}
        </h1>
        }
    </div>

    <!-- Center: Live Status -->
    <div class="hidden md:flex items-center gap-2">
        @switch (signalR.connectionState()) {
        @case ('connected') {
        <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400">
            <span class="size-2 rounded-full bg-green-500 animate-pulse"></span>
            Live
        </span>
        }
        @case ('connecting') {
        <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400">
            <span class="size-2 rounded-full bg-yellow-500 animate-pulse"></span>
            Connecting
        </span>
        }
        @case ('reconnecting') {
        <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400">
            <span class="size-2 rounded-full bg-orange-500 animate-pulse"></span>
            Reconnecting
        </span>
        }
        @case ('disconnected') {
        <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400">
            <span class="size-2 rounded-full bg-red-500"></span>
            Offline
        </span>
        }
        }
        @if (signalR.liveStats()) {
        <span class="text-xs text-gray-400 dark:text-gray-500">{{ signalR.liveStats()!.updatesPerMinute | number:'1.0-1' }} updates/min</span>
        }
    </div>

    <div class="flex items-center space-x-4">
        @if (loginDisplay && accountInfo) {
        <div class="flex items-center space-x-3">
            <div class="text-right">
                <p class="text-sm font-medium text-gray-700 dark:text-gray-200">{{ accountInfo.name }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">{{ accountInfo.username }}</p>
            </div>
            @if (photo) {
            <a routerLink="/profile" class="cursor-pointer">
                <img class="w-10 h-10 rounded-full object-cover bg-gray-100 dark:bg-gray-700 hover:ring-2 hover:ring-primary/50 transition-shadow"
                    [src]="photo" alt="user profile photo">
            </a>
            } @else {
            <a routerLink="/profile"
                class="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center text-white font-semibold cursor-pointer hover:ring-2 hover:ring-primary/50 transition-shadow">
                {{ accountInfo.name?.charAt(0)?.toUpperCase() }}
            </a>
            }
        </div>
        }
    </div>
</header>